import DefaultConfirmButton_m from '@/game/prefabs/DefaultConfirmButton_m';
import DefaultButton from '@/game/prefabs/GeneralUI/Buttons/DefaultButton';
import MinigameScoreScreenController from '@/game/prefabs/Minigame/MinigameScoreScreenController';
import StudentGameAttemptUI from '@/game/prefabs/StudentGame/StudentGameAttemptUI/StudentGameAttemptUI';

/* START OF COMPILED CODE */

export default class MinigameScoreScreen extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// desktopView
		const desktopView = scene.add.container(0, 0);
		desktopView.visible = false;
		this.add(desktopView);

		// backingPanel_1
		const backingPanel_1 = scene.add.nineslice(0, 0, "Hud1", undefined, 300, 144, 12, 12, 12, 12);
		backingPanel_1.scaleX = 4;
		backingPanel_1.scaleY = 4;
		desktopView.add(backingPanel_1);

		// leftPanel
		const leftPanel = scene.add.container(-508, -160);
		desktopView.add(leftPanel);

		// attemptsBacking
		const attemptsBacking = scene.add.nineslice(0, 0, "Hud2", undefined, 166, 108, 10, 10, 10, 10);
		attemptsBacking.scaleX = 4;
		attemptsBacking.scaleY = 4;
		attemptsBacking.setOrigin(0, 0);
		attemptsBacking.alpha = 0.00001;
		leftPanel.add(attemptsBacking);

		// gridScrollBar
		const gridScrollBar = scene.add.container(700, -3);
		leftPanel.add(gridScrollBar);

		// scrollBarBacking
		const scrollBarBacking = scene.add.nineslice(0, 0, "scrollbar-backing", undefined, 8, 97, 2, 2, 2, 2);
		scrollBarBacking.scaleX = 4;
		scrollBarBacking.scaleY = 4;
		scrollBarBacking.setOrigin(0.5, 0);
		gridScrollBar.add(scrollBarBacking);

		// scrollBarHandle
		const scrollBarHandle = scene.add.image(0, 0, "scrollbar-handle");
		scrollBarHandle.scaleX = 4;
		scrollBarHandle.scaleY = 4;
		scrollBarHandle.setOrigin(0.5, 0);
		gridScrollBar.add(scrollBarHandle);

		// attemptsList
		const attemptsList = scene.add.container(0, 0);
		leftPanel.add(attemptsList);

		// headers
		const headers = scene.add.container(0, -40);
		leftPanel.add(headers);

		// headerBreaker
		const headerBreaker = scene.add.image(0, 32, "1x1sprite");
		headerBreaker.scaleX = 660;
		headerBreaker.scaleY = 4;
		headerBreaker.setOrigin(0, 0.5);
		headerBreaker.tintTopLeft = 4864576;
		headerBreaker.tintTopRight = 4864576;
		headerBreaker.tintBottomLeft = 4864576;
		headerBreaker.tintBottomRight = 4864576;
		headers.add(headerBreaker);

		// correctAnswerHeader
		const correctAnswerHeader = scene.add.bitmapText(20, 0, "Aronui", "Correct Answer");
		correctAnswerHeader.tintTopLeft = 4864576;
		correctAnswerHeader.tintTopRight = 4864576;
		correctAnswerHeader.tintBottomLeft = 4864576;
		correctAnswerHeader.tintBottomRight = 4864576;
		correctAnswerHeader.text = "Correct Answer";
		correctAnswerHeader.fontSize = -24;
		headers.add(correctAnswerHeader);

		// yourAnswerHeader
		const yourAnswerHeader = scene.add.bitmapText(256, 0, "Aronui", "Your Answer");
		yourAnswerHeader.tintTopLeft = 4864576;
		yourAnswerHeader.tintTopRight = 4864576;
		yourAnswerHeader.tintBottomLeft = 4864576;
		yourAnswerHeader.tintBottomRight = 4864576;
		yourAnswerHeader.text = "Your Answer";
		yourAnswerHeader.fontSize = -24;
		headers.add(yourAnswerHeader);

		// rightPanel
		const rightPanel = scene.add.container(180, 0);
		desktopView.add(rightPanel);

		// rubiesContainer
		const rubiesContainer = scene.add.container(212, 132);
		rightPanel.add(rubiesContainer);

		// gemBacking
		const gemBacking = scene.add.nineslice(-32, 0, "1x1sprite", undefined, 100, 32, 10, 10, 10, 10);
		gemBacking.setOrigin(0, 0.5);
		gemBacking.tint = 4864576;
		rubiesContainer.add(gemBacking);

		// rubiesText
		const rubiesText = scene.add.bitmapText(0, 0, "Aronui", "+100");
		rubiesText.setOrigin(0, 0.5);
		rubiesText.tintTopLeft = 15130076;
		rubiesText.tintTopRight = 15130076;
		rubiesText.tintBottomLeft = 15130076;
		rubiesText.tintBottomRight = 15130076;
		rubiesText.text = "+100";
		rubiesText.fontSize = -28;
		rubiesContainer.add(rubiesText);

		// rubyIcon
		const rubyIcon = scene.add.image(0, 0, "hud-icons", 95);
		rubyIcon.scaleX = 4;
		rubyIcon.scaleY = 4;
		rubyIcon.setOrigin(1, 0.5);
		rubiesContainer.add(rubyIcon);

		// accuracyContainer
		const accuracyContainer = scene.add.container(224, -136);
		rightPanel.add(accuracyContainer);

		// backing
		const backing = scene.add.nineslice(0, 0, "Hud2", undefined, 66, 32, 10, 10, 10, 10);
		backing.scaleX = 4;
		backing.scaleY = 4;
		accuracyContainer.add(backing);

		// accuracyLabel
		const accuracyLabel = scene.add.bitmapText(-36, -16, "Aronui", "Accuracy");
		accuracyLabel.setOrigin(0, 0.5);
		accuracyLabel.tintTopLeft = 3023407;
		accuracyLabel.tintTopRight = 3023407;
		accuracyLabel.tintBottomLeft = 3023407;
		accuracyLabel.tintBottomRight = 3023407;
		accuracyLabel.text = "Accuracy";
		accuracyLabel.fontSize = -24;
		accuracyContainer.add(accuracyLabel);

		// accuracyValue
		const accuracyValue = scene.add.bitmapText(-36, 12, "Aronui", "100%");
		accuracyValue.setOrigin(0, 0.5);
		accuracyValue.tintTopLeft = 5387071;
		accuracyValue.tintTopRight = 5387071;
		accuracyValue.tintBottomLeft = 5387071;
		accuracyValue.tintBottomRight = 5387071;
		accuracyValue.text = "100%";
		accuracyValue.fontSize = -22;
		accuracyContainer.add(accuracyValue);

		// accuracy_icon
		const accuracy_icon = scene.add.image(-80, -4, "Accuracy");
		accuracy_icon.scaleX = 4;
		accuracy_icon.scaleY = 4;
		accuracyContainer.add(accuracy_icon);

		// timeTakenContainer
		const timeTakenContainer = scene.add.container(224, 8);
		rightPanel.add(timeTakenContainer);

		// backing_1
		const backing_1 = scene.add.nineslice(0, 0, "Hud2", undefined, 66, 32, 10, 10, 10, 10);
		backing_1.scaleX = 4;
		backing_1.scaleY = 4;
		timeTakenContainer.add(backing_1);

		// timeTakenLabel
		const timeTakenLabel = scene.add.bitmapText(-36, -16, "Aronui", "Time Taken");
		timeTakenLabel.setOrigin(0, 0.5);
		timeTakenLabel.tintTopLeft = 3023407;
		timeTakenLabel.tintTopRight = 3023407;
		timeTakenLabel.tintBottomLeft = 3023407;
		timeTakenLabel.tintBottomRight = 3023407;
		timeTakenLabel.text = "Time Taken";
		timeTakenLabel.fontSize = -24;
		timeTakenContainer.add(timeTakenLabel);

		// timeTakenValue
		const timeTakenValue = scene.add.bitmapText(-36, 12, "Aronui", "2 min 35 sec");
		timeTakenValue.setOrigin(0, 0.5);
		timeTakenValue.tintTopLeft = 5387071;
		timeTakenValue.tintTopRight = 5387071;
		timeTakenValue.tintBottomLeft = 5387071;
		timeTakenValue.tintBottomRight = 5387071;
		timeTakenValue.text = "2 min 35 sec";
		timeTakenValue.fontSize = -22;
		timeTakenContainer.add(timeTakenValue);

		// time_icon
		const time_icon = scene.add.image(-80, 0, "clock");
		time_icon.scaleX = 4;
		time_icon.scaleY = 4;
		timeTakenContainer.add(time_icon);

		// finishGameButton
		const finishGameButton = new DefaultButton(scene, 224, 208);
		rightPanel.add(finishGameButton);

		// divider
		const divider = scene.add.image(44, 0, "1x1sprite");
		divider.scaleX = 4;
		divider.scaleY = 448;
		divider.tintTopLeft = 4864576;
		divider.tintTopRight = 4864576;
		divider.tintBottomLeft = 4864576;
		divider.tintBottomRight = 4864576;
		rightPanel.add(divider);

		// headerContainer_1
		const headerContainer_1 = scene.add.container(8, -284);
		desktopView.add(headerContainer_1);

		// headerBacking_1
		const headerBacking_1 = scene.add.nineslice(0, 0, "Hud2", undefined, 96, 24, 8, 8, 8, 8);
		headerBacking_1.scaleX = 4;
		headerBacking_1.scaleY = 4;
		headerContainer_1.add(headerBacking_1);

		// gameTitleText_1
		const gameTitleText_1 = scene.add.bitmapText(0, 0, "Aronui", "Game Complete!");
		gameTitleText_1.setOrigin(0.5, 0.5);
		gameTitleText_1.tintTopLeft = 3023407;
		gameTitleText_1.tintTopRight = 3023407;
		gameTitleText_1.tintBottomLeft = 3023407;
		gameTitleText_1.tintBottomRight = 3023407;
		gameTitleText_1.text = "Game Complete!";
		gameTitleText_1.fontSize = -32;
		headerContainer_1.add(gameTitleText_1);

		// speedBonusTooltip
		const speedBonusTooltip = scene.add.container(0, 0);
		speedBonusTooltip.visible = false;
		desktopView.add(speedBonusTooltip);

		// nineslice
		const nineslice = scene.add.nineslice(0, 0, "Hud2", undefined, 84, 24, 10, 10, 10, 10);
		nineslice.scaleX = 4;
		nineslice.scaleY = 4;
		nineslice.setOrigin(0, 0);
		speedBonusTooltip.add(nineslice);

		// bonusExplanationText
		const bonusExplanationText = scene.add.bitmapText(20, 48, "Aronui", "Speed Bonus!");
		bonusExplanationText.setOrigin(0, 0.5);
		bonusExplanationText.tintTopLeft = 5387071;
		bonusExplanationText.tintTopRight = 5387071;
		bonusExplanationText.tintBottomLeft = 5387071;
		bonusExplanationText.tintBottomRight = 5387071;
		bonusExplanationText.text = "Speed Bonus!";
		bonusExplanationText.fontSize = -24;
		bonusExplanationText.maxWidth = 320;
		speedBonusTooltip.add(bonusExplanationText);

		// bonusRubyContainer
		const bonusRubyContainer = scene.add.container(228, 48);
		speedBonusTooltip.add(bonusRubyContainer);

		// bonusExplanationText_1
		const bonusExplanationText_1 = scene.add.bitmapText(4, 0, "Aronui", "+2");
		bonusExplanationText_1.setOrigin(0, 0.5);
		bonusExplanationText_1.tintTopLeft = 5387071;
		bonusExplanationText_1.tintTopRight = 5387071;
		bonusExplanationText_1.tintBottomLeft = 5387071;
		bonusExplanationText_1.tintBottomRight = 5387071;
		bonusExplanationText_1.text = "+2";
		bonusExplanationText_1.fontSize = -24;
		bonusExplanationText_1.maxWidth = 320;
		bonusRubyContainer.add(bonusExplanationText_1);

		// speedBonusTooltipRubyIcon
		const speedBonusTooltipRubyIcon = scene.add.image(-4, 0, "ruby-small");
		speedBonusTooltipRubyIcon.scaleX = 4;
		speedBonusTooltipRubyIcon.scaleY = 4;
		speedBonusTooltipRubyIcon.setOrigin(1, 0.5);
		bonusRubyContainer.add(speedBonusTooltipRubyIcon);

		// mobileView
		const mobileView = scene.add.container(339, 188);
		this.add(mobileView);

		// backingPanel_m
		const backingPanel_m = scene.add.nineslice(0, 0, "Hud1", undefined, 302, 156, 12, 12, 12, 12);
		backingPanel_m.scaleX = 2;
		backingPanel_m.scaleY = 2;
		mobileView.add(backingPanel_m);

		// leftPanel_m
		const leftPanel_m = scene.add.container(-279, -64);
		mobileView.add(leftPanel_m);

		// attemptsBacking_m
		const attemptsBacking_m = scene.add.nineslice(0, 0, "Hud2", undefined, 96, 73, 10, 10, 10, 10);
		attemptsBacking_m.scaleX = 4;
		attemptsBacking_m.scaleY = 4;
		attemptsBacking_m.setOrigin(0, 0);
		attemptsBacking_m.alpha = 0.00001;
		leftPanel_m.add(attemptsBacking_m);

		// gridScrollBar_m
		const gridScrollBar_m = scene.add.container(344, -4);
		leftPanel_m.add(gridScrollBar_m);

		// scrollBarBacking_m
		const scrollBarBacking_m = scene.add.nineslice(0, 0, "scrollbar-backing", undefined, 8, 105, 2, 2, 2, 2);
		scrollBarBacking_m.scaleX = 2;
		scrollBarBacking_m.scaleY = 2;
		scrollBarBacking_m.setOrigin(0.5, 0);
		gridScrollBar_m.add(scrollBarBacking_m);

		// scrollBarHandle_m
		const scrollBarHandle_m = scene.add.image(0, 0, "scrollbar-handle");
		scrollBarHandle_m.scaleX = 2;
		scrollBarHandle_m.scaleY = 2;
		scrollBarHandle_m.setOrigin(0.5, 0);
		gridScrollBar_m.add(scrollBarHandle_m);

		// attemptsList_m
		const attemptsList_m = scene.add.container(0, 0);
		leftPanel_m.add(attemptsList_m);

		// headers_m
		const headers_m = scene.add.container(0, -48);
		leftPanel_m.add(headers_m);

		// headerBreaker_m
		const headerBreaker_m = scene.add.image(0, 40, "1x1sprite");
		headerBreaker_m.scaleX = 356;
		headerBreaker_m.scaleY = 2;
		headerBreaker_m.setOrigin(0, 0.5);
		headerBreaker_m.tintTopLeft = 4864576;
		headerBreaker_m.tintTopRight = 4864576;
		headerBreaker_m.tintBottomLeft = 4864576;
		headerBreaker_m.tintBottomRight = 4864576;
		headers_m.add(headerBreaker_m);

		// correctAnswerHeader_m
		const correctAnswerHeader_m = scene.add.bitmapText(22, -6, "Aronui", "Correct Answer");
		correctAnswerHeader_m.tintTopLeft = 4864576;
		correctAnswerHeader_m.tintTopRight = 4864576;
		correctAnswerHeader_m.tintBottomLeft = 4864576;
		correctAnswerHeader_m.tintBottomRight = 4864576;
		correctAnswerHeader_m.text = "Correct Answer";
		correctAnswerHeader_m.fontSize = -18;
		correctAnswerHeader_m.maxWidth = 100;
		headers_m.add(correctAnswerHeader_m);

		// yourAnswerHeader_m
		const yourAnswerHeader_m = scene.add.bitmapText(169, -6, "Aronui", "Your Answer");
		yourAnswerHeader_m.tintTopLeft = 4864576;
		yourAnswerHeader_m.tintTopRight = 4864576;
		yourAnswerHeader_m.tintBottomLeft = 4864576;
		yourAnswerHeader_m.tintBottomRight = 4864576;
		yourAnswerHeader_m.text = "Your Answer";
		yourAnswerHeader_m.fontSize = -18;
		yourAnswerHeader_m.maxWidth = 100;
		headers_m.add(yourAnswerHeader_m);

		// rightPanel_m
		const rightPanel_m = scene.add.container(-3, 0);
		mobileView.add(rightPanel_m);

		// rubiesContainer_m
		const rubiesContainer_m = scene.add.container(190, 70);
		rightPanel_m.add(rubiesContainer_m);

		// gemBacking_m
		const gemBacking_m = scene.add.nineslice(0, 0, "1x1sprite", undefined, 100, 32, 10, 10, 10, 10);
		gemBacking_m.tint = 4864576;
		rubiesContainer_m.add(gemBacking_m);

		// rubiesText_m
		const rubiesText_m = scene.add.bitmapText(46.3125, 0, "Aronui", "+100");
		rubiesText_m.setOrigin(1, 0.5);
		rubiesText_m.tintTopLeft = 15130076;
		rubiesText_m.tintTopRight = 15130076;
		rubiesText_m.tintBottomLeft = 15130076;
		rubiesText_m.tintBottomRight = 15130076;
		rubiesText_m.text = "+100";
		rubiesText_m.fontSize = -28;
		rubiesText_m.align = 2;
		rubiesContainer_m.add(rubiesText_m);

		// rubyIcon_m
		const rubyIcon_m = scene.add.image(-18, 0, "hud-icons", 95);
		rubyIcon_m.scaleX = 2;
		rubyIcon_m.scaleY = 2;
		rubyIcon_m.setOrigin(1, 0.5);
		rubiesContainer_m.add(rubyIcon_m);

		// accuracyContainer_m
		const accuracyContainer_m = scene.add.container(190, -96);
		rightPanel_m.add(accuracyContainer_m);

		// accuracyLabel_m
		const accuracyLabel_m = scene.add.bitmapText(-22, -8, "Aronui", "Accuracy");
		accuracyLabel_m.setOrigin(0, 0.5);
		accuracyLabel_m.tintTopLeft = 3023407;
		accuracyLabel_m.tintTopRight = 3023407;
		accuracyLabel_m.tintBottomLeft = 3023407;
		accuracyLabel_m.tintBottomRight = 3023407;
		accuracyLabel_m.text = "Accuracy";
		accuracyLabel_m.fontSize = -16;
		accuracyContainer_m.add(accuracyLabel_m);

		// accuracyValue_m
		const accuracyValue_m = scene.add.bitmapText(-22, 8, "Aronui", "100%");
		accuracyValue_m.setOrigin(0, 0.5);
		accuracyValue_m.tintTopLeft = 5387071;
		accuracyValue_m.tintTopRight = 5387071;
		accuracyValue_m.tintBottomLeft = 5387071;
		accuracyValue_m.tintBottomRight = 5387071;
		accuracyValue_m.text = "100%";
		accuracyValue_m.fontSize = -14;
		accuracyContainer_m.add(accuracyValue_m);

		// accuracy_icon_m
		const accuracy_icon_m = scene.add.image(-30, 0, "Accuracy");
		accuracy_icon_m.scaleX = 2;
		accuracy_icon_m.scaleY = 2;
		accuracy_icon_m.setOrigin(1, 0.5);
		accuracyContainer_m.add(accuracy_icon_m);

		// timeTakenContainer_m
		const timeTakenContainer_m = scene.add.container(190, -48);
		rightPanel_m.add(timeTakenContainer_m);

		// timeTakenLabel_m
		const timeTakenLabel_m = scene.add.bitmapText(-22, -8, "Aronui", "Time Taken");
		timeTakenLabel_m.setOrigin(0, 0.5);
		timeTakenLabel_m.tintTopLeft = 3023407;
		timeTakenLabel_m.tintTopRight = 3023407;
		timeTakenLabel_m.tintBottomLeft = 3023407;
		timeTakenLabel_m.tintBottomRight = 3023407;
		timeTakenLabel_m.text = "Time Taken";
		timeTakenLabel_m.fontSize = -16;
		timeTakenContainer_m.add(timeTakenLabel_m);

		// timeTakenValue_m
		const timeTakenValue_m = scene.add.bitmapText(-22, 8, "Aronui", "2 min 35 sec");
		timeTakenValue_m.setOrigin(0, 0.5);
		timeTakenValue_m.tintTopLeft = 5387071;
		timeTakenValue_m.tintTopRight = 5387071;
		timeTakenValue_m.tintBottomLeft = 5387071;
		timeTakenValue_m.tintBottomRight = 5387071;
		timeTakenValue_m.text = "2 min 35 sec";
		timeTakenValue_m.fontSize = -14;
		timeTakenContainer_m.add(timeTakenValue_m);

		// time_icon_m
		const time_icon_m = scene.add.image(-30, 0, "clock");
		time_icon_m.scaleX = 2;
		time_icon_m.scaleY = 2;
		time_icon_m.setOrigin(1, 0.5);
		timeTakenContainer_m.add(time_icon_m);

		// finishGameButton_m
		const finishGameButton_m = new DefaultConfirmButton_m(scene, 190, 118);
		rightPanel_m.add(finishGameButton_m);

		// divider_m
		const divider_m = scene.add.image(81, -122, "1x1sprite");
		divider_m.scaleX = 2;
		divider_m.scaleY = 264;
		divider_m.setOrigin(0.5, 0);
		divider_m.tintTopLeft = 4864576;
		divider_m.tintTopRight = 4864576;
		divider_m.tintBottomLeft = 4864576;
		divider_m.tintBottomRight = 4864576;
		rightPanel_m.add(divider_m);

		// headerContainer_m
		const headerContainer_m = scene.add.container(1, -152);
		mobileView.add(headerContainer_m);

		// headerBacking_m
		const headerBacking_m = scene.add.nineslice(0, 0, "Hud2", undefined, 128, 22, 4, 4, 4, 4);
		headerBacking_m.scaleX = 2;
		headerBacking_m.scaleY = 2;
		headerContainer_m.add(headerBacking_m);

		// gameTitleText_m
		const gameTitleText_m = scene.add.bitmapText(0, 0, "Aronui", "Game Complete!");
		gameTitleText_m.setOrigin(0.5, 0.5);
		gameTitleText_m.tintTopLeft = 3023407;
		gameTitleText_m.tintTopRight = 3023407;
		gameTitleText_m.tintBottomLeft = 3023407;
		gameTitleText_m.tintBottomRight = 3023407;
		gameTitleText_m.text = "Game Complete!";
		gameTitleText_m.fontSize = -24;
		headerContainer_m.add(gameTitleText_m);

		// speedBonusTooltip_m
		const speedBonusTooltip_m = scene.add.container(-364, 100);
		speedBonusTooltip_m.visible = false;
		mobileView.add(speedBonusTooltip_m);

		// nineslice_1
		const nineslice_1 = scene.add.nineslice(0, 0, "Hud2", undefined, 84, 24, 10, 10, 10, 10);
		nineslice_1.scaleX = 4;
		nineslice_1.scaleY = 4;
		nineslice_1.setOrigin(0, 0);
		speedBonusTooltip_m.add(nineslice_1);

		// bonusExplanationText_2
		const bonusExplanationText_2 = scene.add.bitmapText(20, 48, "Aronui", "Speed Bonus!");
		bonusExplanationText_2.setOrigin(0, 0.5);
		bonusExplanationText_2.tintTopLeft = 5387071;
		bonusExplanationText_2.tintTopRight = 5387071;
		bonusExplanationText_2.tintBottomLeft = 5387071;
		bonusExplanationText_2.tintBottomRight = 5387071;
		bonusExplanationText_2.text = "Speed Bonus!";
		bonusExplanationText_2.fontSize = -24;
		bonusExplanationText_2.maxWidth = 320;
		speedBonusTooltip_m.add(bonusExplanationText_2);

		// bonusRubyContainer_m
		const bonusRubyContainer_m = scene.add.container(228, 48);
		speedBonusTooltip_m.add(bonusRubyContainer_m);

		// bonusExplanationText_3
		const bonusExplanationText_3 = scene.add.bitmapText(4, 0, "Aronui", "+2");
		bonusExplanationText_3.setOrigin(0, 0.5);
		bonusExplanationText_3.tintTopLeft = 5387071;
		bonusExplanationText_3.tintTopRight = 5387071;
		bonusExplanationText_3.tintBottomLeft = 5387071;
		bonusExplanationText_3.tintBottomRight = 5387071;
		bonusExplanationText_3.text = "+2";
		bonusExplanationText_3.fontSize = -24;
		bonusExplanationText_3.maxWidth = 320;
		bonusRubyContainer_m.add(bonusExplanationText_3);

		// speedBonusTooltipRubyIcon_m
		const speedBonusTooltipRubyIcon_m = scene.add.image(-4, 0, "ruby-small");
		speedBonusTooltipRubyIcon_m.scaleX = 4;
		speedBonusTooltipRubyIcon_m.scaleY = 4;
		speedBonusTooltipRubyIcon_m.setOrigin(1, 0.5);
		bonusRubyContainer_m.add(speedBonusTooltipRubyIcon_m);

		// finishGameButton (prefab fields)
		finishGameButton.buttonText = "Continue";

		// finishGameButton_m (prefab fields)
		finishGameButton_m.buttonText = "Continue";

		this.attemptsBacking = attemptsBacking;
		this.scrollBarBacking = scrollBarBacking;
		this.scrollBarHandle = scrollBarHandle;
		this.attemptsList = attemptsList;
		this.correctAnswerHeader = correctAnswerHeader;
		this.yourAnswerHeader = yourAnswerHeader;
		this.rubiesText = rubiesText;
		this.accuracyValue = accuracyValue;
		this.timeTakenValue = timeTakenValue;
		this.finishGameButton = finishGameButton;
		this.speedBonusTooltip = speedBonusTooltip;
		this.desktopView = desktopView;
		this.attemptsBacking_m = attemptsBacking_m;
		this.scrollBarBacking_m = scrollBarBacking_m;
		this.scrollBarHandle_m = scrollBarHandle_m;
		this.attemptsList_m = attemptsList_m;
		this.correctAnswerHeader_m = correctAnswerHeader_m;
		this.yourAnswerHeader_m = yourAnswerHeader_m;
		this.rubiesText_m = rubiesText_m;
		this.accuracyValue_m = accuracyValue_m;
		this.timeTakenValue_m = timeTakenValue_m;
		this.finishGameButton_m = finishGameButton_m;
		this.speedBonusTooltip_m = speedBonusTooltip_m;
		this.mobileView = mobileView;

		/* START-USER-CTR-CODE */
    this._controller = new MinigameScoreScreenController(this);
    /* END-USER-CTR-CODE */
	}

	public attemptsBacking: Phaser.GameObjects.NineSlice;
	public scrollBarBacking: Phaser.GameObjects.NineSlice;
	public scrollBarHandle: Phaser.GameObjects.Image;
	public attemptsList: Phaser.GameObjects.Container;
	public correctAnswerHeader: Phaser.GameObjects.BitmapText;
	public yourAnswerHeader: Phaser.GameObjects.BitmapText;
	public rubiesText: Phaser.GameObjects.BitmapText;
	public accuracyValue: Phaser.GameObjects.BitmapText;
	public timeTakenValue: Phaser.GameObjects.BitmapText;
	public finishGameButton: DefaultButton;
	public speedBonusTooltip: Phaser.GameObjects.Container;
	public desktopView: Phaser.GameObjects.Container;
	public attemptsBacking_m: Phaser.GameObjects.NineSlice;
	public scrollBarBacking_m: Phaser.GameObjects.NineSlice;
	public scrollBarHandle_m: Phaser.GameObjects.Image;
	public attemptsList_m: Phaser.GameObjects.Container;
	public correctAnswerHeader_m: Phaser.GameObjects.BitmapText;
	public yourAnswerHeader_m: Phaser.GameObjects.BitmapText;
	public rubiesText_m: Phaser.GameObjects.BitmapText;
	public accuracyValue_m: Phaser.GameObjects.BitmapText;
	public timeTakenValue_m: Phaser.GameObjects.BitmapText;
	public finishGameButton_m: DefaultConfirmButton_m;
	public speedBonusTooltip_m: Phaser.GameObjects.Container;
	public mobileView: Phaser.GameObjects.Container;

	/* START-USER-CODE */

  private _controller: MinigameScoreScreenController;
  public get controller() {
    return this._controller;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
